import { createLocalExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const CACHE_PREFIX = 'jira_trial_assistant';
const WELCOME_MODAL_STORE_KEY = 'welcome_modal_last_time';
const REMINDER_NUDGE_STORE_KEY = 'reminder_nudge_last_time';

const cache = createLocalExpirableStorageProvider(CACHE_PREFIX);
const TIME_TO_LIVE = 90 * 24 * 60 * 60 * 1000;

export const getWelcomeModalLastSeen = () => {
	const val = cache.get(WELCOME_MODAL_STORE_KEY);
	return typeof val === 'number' && !Number.isNaN(val) ? val : undefined;
};

export const getReminderNudgeLastSeen = () => {
	const val = cache.get(REMINDER_NUDGE_STORE_KEY);
	return typeof val === 'number' && !Number.isNaN(val) ? val : undefined;
};

export const setWelcomeModalLastSeen = (now: number) => {
	cache.set(WELCOME_MODAL_STORE_KEY, now, now + TIME_TO_LIVE);
};

export const setReminderNudgeLastSeen = (now: number) => {
	cache.set(REMINDER_NUDGE_STORE_KEY, now, now + TIME_TO_LIVE);
};
